import { DocumentGateway } from './document-gateway.interface';

export const initDocumentAPI = (apiSlice: any, gateway: DocumentGateway) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['Document', 'Project', 'Video'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        // QUERY DOCUMENT
        getDocumentsByProject: builder.query({
          query: gateway.getDocumentsByProject,
          providesTags: (result = [], error: any, arg: any) => [
            'Document',
            ...result.map(({ projectId }: { projectId: string }) => ({
              type: 'Document',
              projectId,
            })),
          ],
        }),
        getByProjectAndSlug: builder.query({
          query: gateway.getByProjectAndSlug,
          providesTags: ['Document'],
        }),
        getDocumentById: builder.query({
          query: gateway.getDocumentById,
          providesTags: (result = [], error: any, arg: any) => {
            if (!Array.isArray(result)) {
              return ['Document'];
            }
            return [
              'Document',
              ...result.map(({ documentId }: { documentId: string }) => ({
                type: 'Document',
                documentId,
              })),
            ];
          },
        }),
        getDocumentCategories: builder.query({
          query: gateway.getDocumentCategories,
        }),
        getStandardizeDocuments: builder.query({
          query: gateway.getStandardizeDocuments,
        }),
        // MUTATION DOCUMENT
        postDocument: builder.mutation({
          query: gateway.postDocument,
          invalidatesTags: ['Document'],
        }),
        postSingleDocumentStandardized: builder.mutation({
          query: gateway.postSingleDocumentStandardized,
          invalidatesTags: ['Document'],
        }),
        deleteDocument: builder.mutation({
          query: gateway.deleteDocument,
          invalidatesTags: ['Document'],
        }),
        patchDocument: builder.mutation({
          query: gateway.patchDocument,
          invalidatesTags: ['Document'],
        }),
        patchStandardizedDocument: builder.mutation({
          query: gateway.patchStandardizedDocument,
          invalidatesTags: ['Document'],
        }),
        patchValidateDocument: builder.mutation({
          query: gateway.patchValidateDocument,
        }),
        patchRefuseDocument: builder.mutation({
          query: gateway.patchRefuseDocument,
        }),
        patchArchiveDocument: builder.mutation({
          query: gateway.patchArchiveDocument,
          invalidatesTags: ['Document'],
        }),
        patchSignatureExistingDoc: builder.mutation({
          query: gateway.patchSignatureExistingDoc,
        }),
        patchSignatureGeneratingDoc: builder.mutation({
          query: gateway.patchSignatureGeneratingDoc,
        }),
        // TRIGGER
        sendDocumentByMail: builder.query({
          query: gateway.sendDocumentByMail,
        }),
        generateDocument: builder.mutation({
          query: gateway.generateDocument,
          invalidatesTags: ['Document'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface DocumentSliceType {
  useGetDocumentsByProjectQuery: Function;
  useLazyGetDocumentsByProjectQuery: Function;
  useGetByProjectAndSlugQuery: Function;
  useLazyGetByProjectAndSlugQuery: Function;
  useGetDocumentByIdQuery: Function;
  useLazyGetDocumentByIdQuery: Function;
  useGetDocumentCategoriesQuery: Function;
  useLazyGetDocumentCategoriesQuery: Function;
  useGetStandardizeDocumentsQuery: Function;
  useLazyGetStandardizeDocumentsQuery: Function;
  usePostDocumentMutation: Function;
  usePostSingleDocumentStandardizedMutation: Function;
  useDeleteDocumentMutation: Function;
  usePatchDocumentMutation: Function;
  usePatchStandardizedDocumentMutation: Function;
  usePatchValidateDocumentMutation: Function;
  usePatchRefuseDocumentMutation: Function;
  usePatchArchiveDocumentMutation: Function;
  usePatchSignatureExistingDocMutation: Function;
  usePatchSignatureGeneratingDocMutation: Function;
  useSendDocumentByMailQuery: Function;
  useGenerateDocumentMutation: Function;
}
